// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","primary":"Button_primary__9MLUH","ghost":"Button_ghost__f2-K0"};